import { render, staticRenderFns } from "./BusinessStakeholdersControl.vue?vue&type=template&id=023faec8&"
import script from "./BusinessStakeholdersControl.vue?vue&type=script&lang=js&"
export * from "./BusinessStakeholdersControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports